import React, { useState } from 'react'
import Logoimg from "../images/logo.png"
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

export default function Review() {

    const navigate = useNavigate();

    const [feedbacktext, setFeedbacktext] = useState('');
    const [suggestions, setSuggestions] = useState('');
    const [loading, setLoading] = useState(false);
    const [showAlertBox, setShowAlertBox] = useState(false);
    const [alertMsg, setAlertMsg] = useState('');

    function backtodash() {
        navigate('/dashboard');
    }

    async function sendreview() {

        let username = localStorage.getItem('membername');
        let userrole = localStorage.getItem('mem_permission');
        let com_id = localStorage.getItem('mem_company_id');
        let com_name = localStorage.getItem('mem_company_name');

        // validation
        if (feedbacktext.trim() === '' && suggestions.trim() === '') {
            showAlert("Please write review or suggestion");
            return;
        }
        setLoading(true);
        try {
            const response = await axios.post(
                "save-review.php",
                {
                    username: username,
                    userrole: userrole,
                    com_id: com_id,
                    com_name: com_name,
                    review_text: feedbacktext,
                    sugges_text: suggestions
                }
            );
            if (response.data.status === "success") {
                showAlert("Thank you for your feedback!");
                setFeedbacktext('');
                setSuggestions('');
                navigate('/dashboard');
            } else {
                showAlert(response.data.message);
            }
        } catch (error) {
            console.log(error);
            alert("Something went wrong");
        }

        setLoading(false);
    }

    const showAlert = (msg) => {
        setAlertMsg(msg);
        setShowAlertBox(true);
    };

    const closeAlert = () => {
        setShowAlertBox(false);
        setAlertMsg('');
    };

    return (
        <div>
            <div className='container_small'>

                <div className='logoholder'>
                    <img src={Logoimg} alt="logo" />
                </div>

                <div className='contentholder fullwidth pull_left'>

                    <h2 className='details_pop_heading'>
                        We would love to hear your feedback about our service.
                    </h2>

                    <div className='suggestionbox'>
                        <label>Say something about our service</label>
                        <textarea
                            id="feedbacktext"
                            placeholder='Insert your feedback'
                            value={feedbacktext}
                            onChange={(e) => setFeedbacktext(e.target.value)}
                        ></textarea>
                    </div>

                    <h2 className='details_pop_heading'>
                        Help us to improve more.
                    </h2>

                    <div className='suggestionbox'>
                        <label>Give your valuable opinion to improve more</label>
                        <textarea
                            id="suggestions"
                            placeholder='Insert your opinion'
                            value={suggestions}
                            onChange={(e) => setSuggestions(e.target.value)}
                        ></textarea>

                        <div className='vl_dsh_buttonholder'>

                            <button
                                className='mr-10'
                                onClick={sendreview}
                                disabled={loading}
                            >
                                {loading ? 'Sending...' : 'Send Review'}
                            </button>

                            <button
                                className='mr-10'
                                onClick={backtodash}
                            >
                                Not Now
                            </button>

                        </div>

                    </div>

                </div>
            </div>
            {showAlertBox && (
        <div className='vl_dsh_popup activebillpop'>
          <div className='alertbox'>
            <div className='alertheader'>
              <h3><i className='ri-alert-line'></i>Alert</h3>
            </div>

            <div className='contentarea'>
              <p>{alertMsg}</p>
            </div>

            <div className='alert_btns'>
              <button onClick={closeAlert}>Okay</button>
            </div>
          </div>
        </div>
      )}
        </div>
    )
}